export default "__VITE_ASSET__BrKnOLBg__"